class AlgoliaMainPredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.searchInput = null;
    this.modal = null;
    this.modalSearchInput = null;
    this.lastQueryID = null;

    this.boundOnSearchInputClick = this.onSearchInputClick.bind(this);
    this.boundOnSearchInputFocus = this.onSearchInputFocus.bind(this);
    this.boundOnModalShow = this.onModalShow.bind(this);
    this.boundOnModalHide = this.onModalHide.bind(this);
    this.boundHandleSearchResultClick = this.handleSearchResultClick.bind(this);
  }

  connectedCallback() {
    this.searchInput = this.querySelector('[data-search-input]');
    this.modal = this.querySelector('x-modal');
    this.customer = this.dataset.customerId || null;
    
    this.setDefaultSearchTerm();
    
    if (this.searchInput) {
      this.searchInput.addEventListener('click', this.boundOnSearchInputClick);
      this.searchInput.addEventListener('focus', this.boundOnSearchInputFocus);
    }

    if (this.modal) {
      this.modal.addEventListener('modal:afterShow', this.boundOnModalShow);
      this.modal.addEventListener('modal:afterHide', this.boundOnModalHide);
    }

    this.addEventListener('click', this.boundHandleSearchResultClick);
  }

  disconnectedCallback() {
    if (this.searchInput) {
      this.searchInput.removeEventListener('click', this.boundOnSearchInputClick);
      this.searchInput.removeEventListener('focus', this.boundOnSearchInputFocus);
    }
    
    if (this.modal) {
      this.modal.removeEventListener('modal:afterShow', this.boundOnModalShow);
      this.modal.removeEventListener('modal:afterHide', this.boundOnModalHide);
    }

    this.removeEventListener('click', this.boundHandleSearchResultClick);
  }

  onSearchInputClick(event) {
    event.preventDefault();
    
    if (this.modal) {
      this.modal.show();
    }
  }

  onSearchInputFocus() {
    if (this.modal) {
      this.modal.show();
    }
  }

  onModalShow() {
    requestAnimationFrame(() => {
      this.modalSearchInput = this.modal.querySelector('input[type="search"]');
      
      if (this.modalSearchInput) {
        const searchTerm = this.getSearchTermFromURL();
        if (searchTerm) {
          this.modalSearchInput.value = searchTerm;
        }
        
        this.modalSearchInput.focus();
        this.modalSearchInput.select();
      }

      // Get the lastQueryID from the predictive search component
      const predictiveSearch = this.modal.querySelector('algolia-predictive-search');
      if (predictiveSearch && predictiveSearch.lastQueryID) {
        this.lastQueryID = predictiveSearch.lastQueryID;
      }
    });
  }

  onModalHide() {
    // Sync the search term from modal input back to visible input
    requestAnimationFrame(() => {
      if (this.modalSearchInput && this.searchInput) {
        this.searchInput.value = this.modalSearchInput.value;
      }
    });
  }

  setDefaultSearchTerm() {
    const searchTerm = this.getSearchTermFromURL();
    if (searchTerm && this.searchInput) {
      this.searchInput.value = searchTerm;
    }
  }

  handleSearchResultClick(event) {
    const productCard = event.target.closest('[data-object-id]');
    if (!productCard) return;
    
    const query = this.modalSearchInput ? this.modalSearchInput.value : '';
    if (!query) return;

    const objectId = productCard.getAttribute('data-object-id');
    const position = productCard.getAttribute('data-position');
    
    if (!objectId || !this.lastQueryID) return;
    
    // Send clickedObjectIDsAfterSearch event to Algolia

    if (typeof aa !== 'function') {
      console.warn('Algolia analytics not loaded');
      return;
    }
    
    aa('clickedObjectIDsAfterSearch', {
      userToken: this.customer || 'guest',
      eventName: 'Product Clicked',
      index: 'shopify_products',
      queryID: this.lastQueryID,
      objectIDs: [objectId],
      positions: [position ? parseInt(position) : 1]
    });
  }

  getSearchTermFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('q') || '';
  }
}

customElements.define('algolia-main-predictive-search', AlgoliaMainPredictiveSearch); 